import React, { useEffect } from 'react';
import { getDevice } from '@panel/commons/helpers';
import { isSiteWithTelBanner } from '@panel/commons/helpers';
import Loader from '@panel/commons/lib/SimpleLoader';
import { useQuery } from '@panel/commons/hooks';
import useBannerLogic from '../../hooks/useBannerLogic';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import { Wrapper, WrapperContent, WrapperBackground, LoaderWrapper } from './styles';
import Stepper from '../Stepper';
import StepHeader from '../StepHeader';
import CommonFormWrapper from '../commons/CommonFormWrapper';
import ButtonPanel from '../ButtonPanel';
import StepTitle from '../StepTitle';
import { SavePostingSelectors } from '../../ducks/savePosting';
import { useDispatch, useSelector } from 'react-redux';
import useShowLoader from '../../hooks/useShowLoader';
import { StepperOperations } from '../../ducks/stepper';
import { getStepMainSelectors, StepMainOperations } from '../../ducks/propertyType';
import Tips from '../Tips';
import BannerInfo from '../BannerInfo';
import useFormIsDirty from '../../hooks/useFormIsDirty';

const WrapperContainer = ({
  id,
  children,
  // Props para el identificador del Step en el header:
  showSaveAndExitButton = true,
  // Props para el Stepper (progress bar):
  showStepper = true,
  // Props para el title y note del Step:
  title = '',
  note = '',
  // Props para el ButtonPanel:
  onSubmit = () => {},
  disabledSubmit = false,
  showBackButton = true,
  btnSubmitText,
  getIsValidForm = () => {},
  formValuesLoading = false,
  loadError = false,
  resetInfo = () => {},
  // Prop para consejos
  isPlanEmpty = false,
  tips = [],
  planName = '',
  selectedOperationType = '',
  selectedPropertyType = '',
  selectedPropertySubType = '',
  enableBackButton = true,
  showTips = true
}) => {
  const device = getDevice();
  const isMobile = device === 'mobile';
  const { saving, postingId } = useSelector(SavePostingSelectors.getSavePostingState);
  const [postingIdFromURL, isEdition, isDraftFromPanel] = useQuery(useLocation(), [
    'postingId',
    'isEdition',
    'isDraftFromPanel'
  ]);
  const { showLoader } = useShowLoader(saving || formValuesLoading);
  const dispatch = useDispatch();
  const location = useLocation();
  const isMainRoute = location.pathname.includes('main');
  const isLocationRoute = location.pathname.includes('location');
  const { cleanFormIsDirty } = useFormIsDirty();
  const { showBannerOldReppro } = useBannerLogic(isMainRoute, isDraftFromPanel, isLocationRoute, false, isMobile);
  const mainData = useSelector(getStepMainSelectors);

  useEffect(() => {
    // Efecto para resetear el estado del isDirty del reducer cada vez que se cambia de paso
    cleanFormIsDirty();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (postingId || postingIdFromURL) {
      dispatch(StepperOperations.getPostingLastStep(postingId || postingIdFromURL));
    }
    if (!isMainRoute) {
      dispatch(StepMainOperations.getFormValues(postingId || postingIdFromURL));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <WrapperBackground device={device}>
        {showBannerOldReppro && (
          <BannerInfo
            dataPubli='edition-view-banner-info'
            isEdition={isEdition || isDraftFromPanel}
            postingId={postingIdFromURL || postingId || ''}
          />
        )}
        <Wrapper device={device} data-publi={`publicador-wrapper-${id}`}>
          <StepHeader
            showSaveAndExitButton={showSaveAndExitButton && !isEdition && !isPlanEmpty}
            id={id}
            onSubmit={onSubmit}
            isMobile={isMobile}
            getIsValidForm={getIsValidForm}
            isPlanEmpty={isPlanEmpty}
            mainData={mainData}
            isEdition={isEdition}
            postingId={postingIdFromURL}
            planName={planName}
            isDraftFromPanel={isDraftFromPanel}
            selectedOperationType={selectedOperationType}
            selectedPropertyType={selectedPropertyType}
            selectedPropertySubType={selectedPropertySubType}
          />
          {showStepper && <Stepper />}
          <WrapperContent isMobileDevice={isMobile} isSiteWithTelBanner={isSiteWithTelBanner}>
            <div>
              <StepTitle title={title} note={note} isMobileDevice={isMobile} />
              {showTips && <Tips device={device} tips={tips} />}
              <CommonFormWrapper>{children}</CommonFormWrapper>
            </div>

            {!formValuesLoading && (
              <ButtonPanel
                onSubmit={onSubmit}
                showBackButton={showBackButton}
                btnSubmitText={btnSubmitText}
                id={id}
                loadError={loadError}
                resetInfo={resetInfo}
                device={device}
                mainData={mainData}
                isEdition={isEdition}
                postingId={postingIdFromURL}
                planName={planName}
                isPlanEmpty={isPlanEmpty}
                getIsValidForm={getIsValidForm}
                selectedOperationType={selectedOperationType}
                selectedPropertyType={selectedPropertyType}
                selectedPropertySubType={selectedPropertySubType}
                enableBackButton={enableBackButton}
                disabledSubmit={disabledSubmit}
              />
            )}
          </WrapperContent>
        </Wrapper>
        {showLoader && (
          <LoaderWrapper>
            <Loader width='96px' height='96px' />
          </LoaderWrapper>
        )}
      </WrapperBackground>
    </>
  );
};

export default WrapperContainer;
